<template>
  <div class="part">
    <div class="layout-page-heading">
      <div class="iconClock">
        <img src="../../assets/img/iconClock.png" alt="">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>预约列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="layout-page-box">
      <el-form :inline="true" label-width="100px" label-position="right" class="search-form">
        <el-form-item label="预约编号">
          <el-input ref="searchInput" class="modalDiaLog" v-model.trim="filters.appointmentId" clearable></el-input>
        </el-form-item>
        <el-form-item label="客户姓名">
          <el-input v-model="filters.customerName" clearable></el-input>
        </el-form-item>
        <el-form-item label="操作人">
          <el-input v-model="filters.doctorName" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="filters.mobile" clearable></el-input>
        </el-form-item>
        <el-form-item label="项目">
          <el-input v-model="filters.projectName" clearable></el-input>
        </el-form-item>
        <el-form-item label="仪器">
          <el-input v-model="filters.instrumentName" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="filters.operationStatus" clearable="" placeholder="选择预约状态">
            <el-option v-for="(item,index) in optionsStatus" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="初/复诊">
          <el-select v-model.trim="filters.appointStatus" clearable="" placeholder="请选择初复诊">
            <el-option v-for="(item) in typeOptions" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门" v-if="isHandle=='1'">
          <el-select v-model.trim="filters.departmentCode" clearable="" placeholder="请选择部门">
            <el-option v-for="(item) in codeTypes" :key="item.id" :label="item.value" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <div class="checkButton">
          <el-form-item label="预约时间">
            <el-date-picker v-model="filters.startTime" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="完成时间">
            <el-date-picker v-model="filters.completionStartTime" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="query(1)">查询</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <div class="layout-page-box">
      <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" height="405" :header-cell-style="{color:'#626365'}" :row-class-name="tableRowClassName">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="预约门诊时间" width="80">
          <template slot-scope="scope">
            <div>{{scope.row.appointmentTime.split(' ')[0]}}</div>
            <div>{{scope.row.appointmentTime.split(' ')[1]}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="customerName" label="客户" width="110"></el-table-column>
        <el-table-column prop="mobile" label="手机号" width="110">
          <template slot-scope="scope">
            <div>{{scope.row.mobile.replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2")}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="appointmentId" label="预约号"></el-table-column>
        <el-table-column prop="projectName" label="项目" width="80"></el-table-column>
        <el-table-column prop="instrumentTime" label="仪器部位使用时间">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.instrumentTime" placement="top">
              <!-- el-tooltip显示内容换行插槽 -->
              <div slot="content">
                <div v-if="scope.row.instrumentTime">
                  <div v-for="(item,index) in scope.row.instrumentTime.split(',')" :key="index">
                    <span>{{item}}</span>
                  </div>
                </div>
              </div>
              <div v-if="scope.row.instrumentTime" class="showOverTooltip">
                <div v-for="(item,index) in scope.row.instrumentTime.split(',')" :key="index">
                  <span>{{item}}</span>
                </div>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="doctorName" label="操作人" width="80"></el-table-column>
        <el-table-column prop="appointStatus" label="初/复诊" width="80"></el-table-column>
        <el-table-column prop="userName" label="预约人"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="100"></el-table-column>
        <el-table-column prop="completionTime" label="完成/取消" width="100"></el-table-column>
        <el-table-column prop="operationStatus" label="状态" width="80"></el-table-column>
        <el-table-column prop="remark" label="备注" show-overflow-tooltip></el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "member",
  data() {
    return {
      copyDialogForm: false,
      searchArr: [],
      filters: {
        types: "",
        pagination: {
          page: 1,
          limit: 10,
          total: 0,
        },
        startTime: "",
        endTime: "",
        appointmentId: '',
        customerName: '',
        doctorName: '',
        // createName: '',
        mobile: '',
        projectName: '',
        instrumentName: '',
        operationStatus: ''
      },
      formTableLIst: {},
      form: {
        positionName: "",
        AppointmentProject: [{
          projectName: "",
          instrumentName: "",
          doctorName: "",
          positionName: "",
          operationStatus: "",
          projectInstrument: [],
          projectDoctor: [],
          remark: "",
          showTime: false,
          successAppointTime: '',
          appointmentPosition: [{
            positionId: '',
            useTime: '',
            positionName: '',
          }],
        },],
      },
      typeOptions: [{
        text: '初诊',
        value: 0
      },
      {
        text: '复诊',
        value: 1
      },
      {
        text: 'VIP',
        value: 2
      },
      ],
      optionsStatus: [{
        label: '待完成',
        value: 3
      },
      {
        label: '已取消',
        value: 1
      },
      {
        label: '已完成',
        value: 2
      },
      ],
      areaOptions: [{
        areaName: '伯思立',
        areaCode: 'bsl'
      }],
      floorOptions: [{
        floorName: '2楼',
        floorCode: '2'
      }, {
        floorName: '3楼',
        floorCode: '3'
      },
      {
        floorName: '12楼',
        floorCode: '12'
      },
      ],
      multipleSelection: [],
      dialogFormVisible: false,
      appointmentId: "",
      tableData: [],
      projectOptions: [],
      projectData: [],
      EditdialogForm: false,
      formData: {},
      disabled: false,
      projectInstrument: [],
      projectDoctor: [],
      arrList1: [],
      arrList2: [],
      dataParam: "",
      listName1: '',
      listName2: '',
      listName3: '',
      listName4: '',
      arrList3: [],
      arrList4: [],
      projectIdData: '',
      disabledDate: {
        disabledDate: (time) => {
          return time.getTime() < new Date().getTime() - 8.64e7
        },
      },
      disabledDateNew: {},
      disabledDateEdit: {},
      projectDoctorList: [],
      instrumentEcho: '',
      projectInfoList: [],
      editEppointmentPosition: {},
      editPositionOptions: {},
      positionEcho: '',
      appointmentList: {},
      instrumentNum: '',
      focusTime: '',
      editShowTime: false,
      editSuccessAppointTime: '',
      areaType: Lockr.get('areaType'),
      isHandle: Lockr.get('isHandle'),
      departmentCode: Lockr.get('departmentCode'),
      codeTypes: [],
    };
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    pageChanged(page) {
      this.filters.pagination.page = page;
      this.refresh();
    },

    handleSizeChange(sizes) {
      this.filters.pagination.limit = sizes;
      this.refresh();
    },
    refresh() {
      router.push({
        path: this.$route.path,
        query: _.merge({},
          this.$route.query, {
            __query: JSON.stringify(this.pagination),
          }, {
            random: Math.random(),
          }
        ),
      });
    },
    // 查询数据列表
    query(page) {
      // console.log(this.filters.completionStartTime)
      let empId = Lockr.get("empId");
      let clientType = Lockr.get("clientType");
      var querys = {
        appointmentId: this.filters.appointmentId,
        customerName: this.filters.customerName,
        doctorName: this.filters.doctorName,
        // createName: this.filters.createName,
        mobile: this.filters.mobile,
        projectName: this.filters.projectName,
        instrumentName: this.filters.instrumentName,
        operationStatus: this.filters.operationStatus,
        completionStartTime: "",
        completionEndTime: "",
        startTime: "",
        endTime: "",
        page: page,
        size: this.filters.pagination.limit,
        clientType: clientType,
        userId: '',
        areaType: this.areaType,
        areaCode: this.areaType,
        departmentCode: this.filters.departmentCode,
        appointStatus: this.filters.appointStatus,
      };
      if (this.filters.startTime) {
        querys.startTime = this.filters.startTime[0];
        querys.endTime = this.filters.startTime[1];
      }
      if (this.filters.completionStartTime) {
        querys.completionStartTime = this.filters.completionStartTime[0];
        querys.completionEndTime = this.filters.completionStartTime[1];
      }
      // console.log(querys)
      api.requestQuiet("/appointment/findAppointmentPage", querys, (res) => {
        // console.log(res)
        var data = res.data.list;
        this.tableData = data
        this.orgData = data;
        this.filters.pagination.total = parseInt(res.data.total);
      }, (err) => { });
    },
    // 表格不同行设置不同的样式
    tableRowClassName({
      row,
      rowIndex
    }) {
      if (row.operationStatus == '待完成' && row.appointStatus == '初诊') {
        return 'warningRed';
      } else if (row.operationStatus == '待完成' && row.appointStatus == 'VIP') {
        return 'warningBlue';
      }
      return '';
    },
  },
  mounted() {
    console.log(this.departmentCode);
    if (this.departmentCode == '2') {
      this.codeTypes = [
        {
          id: 9,
          value: '客服一部网电',
        },
      ]
    } else if (this.departmentCode == '3') {
      this.codeTypes = [
        {
          id: 10,
          value: '伯思立客服三部',
        },
        {
          id: 7,
          value: '伯思立客服二部现场',
        },
      ]
    } else if (this.departmentCode == '13') {
      this.codeTypes = [
        {
          id: 8,
          value: '百翡客服二部现场',
        },
        {
          id: 11,
          value: '百翡客服三部',
        },
      ]
    }
    /*this.init();*/
    this.query(this.filters.pagination.page);
  },
  watch: {
    $route(to, from) {
      this.query(this.filters.pagination.page);
    },
  },
};
</script>
<style>
.el-tooltip__popper[x-placement^="top"] {
  width: 150px !important;
}
</style>

<style scoped>
@import "../../assets/css/main.css";

.part >>> .el-dialog--center .el-dialog__body {
  text-align: center;
  margin-bottom: 25px !important;
  padding-bottom: 0 !important;
  box-sizing: border-box;
}

.partFooter {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.clearBottom >>> .el-form-item {
  margin-bottom: 0 !important;
}

.partFooter >>> .el-button--primary {
  width: 125px;
  height: 34px;
  background: #5a7ef8;
  border-radius: 17px;
  line-height: 5px;
}

.checkButton >>> .el-button--primary {
  width: 98px;
  height: 34px;
  background: #5a7ef8;
  border-radius: 17px;
  line-height: 5px;
}

.partFooter >>> .el-button--danger {
  width: 125px;
  height: 34px;
  border-radius: 17px;
  border: 1px solid #5a7ef8;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #5a7ef8;
  line-height: 2px;
  background: none;
}

.pageInput >>> .el-input__inner {
  width: 400px;
  height: 38px;
  background: #f6f7fb;
  border-radius: 23px;
  border: none;
}

.pageInput >>> .el-button {
  height: 34px;
  border-radius: 17px;
  border: 1px solid #979797;
  line-height: 5px;
  margin-left: 8px;
}

.iconClock {
  display: flex;
  align-items: center;
}

.iconClock img {
  height: 20px;
  margin-right: 5px;
}

.el-table >>> .warningRed {
  color: #f56c6c;
}

.el-table >>> .warningBlue {
  color: #1b84ed;
}
.showOverTooltip {
  display: -webkit-box;
  text-overflow: ellipsis;
  overflow: hidden;
  /*这里是3行*/
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  cursor: pointer;
}
</style>